import { combineReducers } from 'redux';
import notificationReducer from './notification/notification.reducer';

const rootReducer = combineReducers({ notificationReducer });

export default rootReducer;
